import * as yup from 'yup';

import { YUP_OLD_EMAIL_REGEX } from '@clearverify/constants';

import { passwordValidationSchema } from 'src/constants/validation';

import { LoginFormField } from '../types';

const emailValidationSchema = yup
  .string()
  .typeError('Required')
  .matches(YUP_OLD_EMAIL_REGEX, 'Format is incorrect')
  .required('Email is required');

export const loginValidationSchema = yup.object({
  [LoginFormField.email]: emailValidationSchema,
  [LoginFormField.password]: passwordValidationSchema.required('Password is required'),
});
